

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { API } from 'aws-amplify';

 // import Prism Editor
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-yaml';
import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
import DebounceAsync from '@/utility/DebounceAsync';
declare var Prism: any;

@Component({
  components: {
    PrismEditor,
  },
})
export default class NoteTemplate extends Vue {
    private debounceAsync: DebounceAsync = new DebounceAsync();

    @Prop()
    public type: string;

    public content: string = '';

    public selectedVersion: string = '';
    public versions: string[] = [];

    public get signedIn(): boolean {
        return this.$root.$data.signedIn;
    }

    public highlighter(code: string) {
        return Prism.highlight(code, Prism.languages.yaml);
    }

    public async created() {
        const result = await this.debounceAsync.invoke(this.getLatestTemplate);
        this.content = result.template;
        this.selectedVersion = result.name;
    }

    private async getLatestTemplate(): Promise<any> {
        return await API.get('RestApi', `/config/template/${this.type}/latest`, {});
    }

    private async getTemplateList(): Promise<any> {
        return await API.get('RestApi', `/config/template/${this.type}`, {});
    }

    private async save(): Promise<any> {
        const result = await this.debounceAsync.invoke(this.updateTemplate);
        this.$emit('saved', result);
    }

    private async updateTemplate(): Promise<any> {
        return await API.post('RestApi', `/config/template/${this.type}`, {
            body: {
                name: this.selectedVersion,
                template: this.content,
            },
        });
    }
}
